import * as Yup from "yup";
import { contactPrefs } from "../../../";
import * as domain from "../../../domain";

const tagShape = Yup.object().shape({
    tagId: Yup.number(),
    tagTypeId: Yup.number(),
    tagName: Yup.string(),
    canMatch: Yup.boolean(),
    isMatched: Yup.boolean(),
    canEdit: Yup.boolean(),
});

export const createReviewCandidateSchema = Yup.object().shape({
    // interview availability
    stepOne: Yup.object().shape({
        isInterviewingElsewhere: Yup.bool().default(false),
        interviewingElsewhereNote: Yup.string()
            .trim()
            .when("isInterviewingElsewhere", {
                is: val =>
                    val !== null &&
                    val !== undefined &&
                    val !== false &&
                    val !== "no",
                then: Yup.string().required(
                    "please provide where the candidate is at in their other interview process"
                ),
            })
            .nullable(true),
        interviewAvailabilityNote: Yup.string()
            .trim()
            .default(undefined)
            .required("interview availability notes are required"),
        timeZone: Yup.number()
            .default(undefined)
            .nullable(true)
            .required("please provide a time zone"),
        bestTimesToReach: Yup.array(tagShape)
            .test({
                name: "bestTimesToReachRequired",
                test: function (value: any[]) {
                    const times = contactPrefs.timeOfDay.reduce(
                        (acc, td) => acc.concat(td.times),
                        [] as domain.TagMatchType[]
                    );

                    const hasTimes = [times, value]
                        .reduce((acc, v) =>
                            acc.filter(
                                f => !!v.find(vf => f.tagId === vf.tagId)
                            )
                        )
                        .some(s => s);

                    if (!hasTimes) {
                        return this.createError({
                            path: "stepTwo.bestTimesToReach",
                            message: "must select at least one time of day",
                        });
                    }
                    return true;
                },
            })
            .nullable(true),
        noticeAvailability: Yup.number()
            .default(undefined)
            .nullable(true)
            .required("please provide availability"),
    }),

    // formatted resume
    stepTwo: Yup.object().shape({
        formattedResume: Yup.object()
            .default(undefined)
            .nullable(true)
            .required("a formatted resume is required"),
    }),

    // additional information
    stepThree: Yup.object().shape({
        additionalInformation: Yup.string()
            .default(undefined)
            .nullable(true)
    }),

    // candidate verification
    stepFour: Yup.object().shape({
        reviewRequiresVerification: Yup.boolean().default(false),
        sendSms: Yup.boolean()
            .when("reviewRequiresVerification", {
                is: val => val !== null && val !== undefined && val !== false,
                then: Yup.boolean().test({
                    name: "verificationRequired",
                    // tslint:disable-next-line object-literal-shorthand only-arrow-functions
                    test: function (value: boolean) {
                        const { sendEmail = false } = this.parent;
                        if (!sendEmail && !value) {
                            return this.createError({
                                path: "stepFive.sendSms",
                                message:
                                    "email and/or text must be chosen to send the verification to the candidate",
                            });
                        }
                        return true;
                    },
                }),
            })
            .default(true),
    }),
});
